import type { useSignUp } from '@clerk/react';

interface CreateSignUpParams {
  strategy: 'ticket';
  ticket: string;
  firstName?: string;
  lastName?: string;
  password?: string;
}

// Clerk v6 typed API (.ticket()) does not bind invitation email when the instance
// requires password. The runtime .create() method works correctly — it sends
// strategy=ticket with all fields in a single API call, which binds the email
// from the invitation token. This method exists at runtime but is not in v6 types.
//
// TODO: Remove when Clerk fixes .ticket() for password-required instances.
export function createSignUp(
  signUp: ReturnType<typeof useSignUp>['signUp'],
  params: CreateSignUpParams
): Promise<{ error: unknown }> {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
  return (signUp as any).create(params);
}
